import { h } from 'preact';
import Store from 'store/store';
import { findInVNode } from 'utils/vnode';
import * as BaseComp from 'components/bolt/header/sharePopout.js';
import s from 'components/bolt/header/sharePopout.sss';

export default class SharePopout extends BaseComp.default {
	render(props, state) {
		const base = super.render(props, state);
		const isDesktopSize = Store.get()?.client?.isDesktopSize;
		const hasUarHeader = props?.appData?.header?.uarHeader;

		if (hasUarHeader && isDesktopSize) {
			const container = findInVNode(base, `.${s.container}`);
			container.attributes.style = {
				...container.attributes.style,
				marginTop: '134px'
			};
		}
		return base;
	}
}
